module.exports = __webpack_public_path__ + "img/02_1.13adf324.png";